import React from "react";
import "../styles/06-pages/adminDashboard.scss";

export default function AdminDashboard() {
  const company = {
    phoneClicks: 120,
    emailRequests: 85,
    firstContacts: 40,
    confirmedBookings: 65,
  };

  const users = {
    successfulBookings: 52,
    profilesCreated: 110,
    callsMade: 33,
    failedBookings: 20,
    failedRequests: 12,
    newUsers: 75,
  };

  return (
    <section className="admin-section">
      <div className="admin-container">
        <header className="admin-header">
          <h1 className="admin-title">
            <span className="title-highlight">Off</span>Together – Admin KPIs
          </h1>
          <p className="admin-description">
            Übersicht wichtiger Kennzahlen für Unternehmen und
            Nutzeraktivitäten.
          </p>
        </header>

        {/* Unternehmen */}
        <div className="section-header">
          <h2 className="section-title">Unternehmen</h2>
          <p className="section-subtitle">Interaktionen & Buchungen</p>
        </div>

        <div className="admin-grid">
          <div className="kpi-card">
            <div className="stat-title">Telefon Klicks</div>
            <div className="stat-value">{company.phoneClicks}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">E-Mail Anfragen</div>
            <div className="stat-value">{company.emailRequests}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Erste Kontaktaufnahme</div>
            <div className="stat-value">{company.firstContacts}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Bestätigte Buchungen</div>
            <div className="stat-value">{company.confirmedBookings}</div>
          </div>
        </div>

        {/* Nutzer */}
        <div className="section-header" style={{ marginTop: "3rem" }}>
          <h2 className="section-title">User – Kennzahlen</h2>
          <p className="section-subtitle">Woran messen wir unseren Erfolg?</p>
        </div>

        <div className="admin-grid">
          <div className="kpi-card">
            <div className="stat-title">Buchungen zustande gekommen</div>
            <div className="stat-value">{users.successfulBookings}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Spielerprofile angelegt</div>
            <div className="stat-value">{users.profilesCreated}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Anrufe über App</div>
            <div className="stat-value">{users.callsMade}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Buchungsanfragen nicht zustande</div>
            <div className="stat-value">{users.failedBookings}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Spieleranfragen nicht zustande</div>
            <div className="stat-value">{users.failedRequests}</div>
          </div>
          <div className="kpi-card">
            <div className="stat-title">Neue User pro Monat</div>
            <div className="stat-value">{users.newUsers}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
